// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zVkWq","number":"Card_number__v3cr-","right":"Card_right__Szi8e","title":"Card_title__5zRE+","description":"Card_description__x0Dft"};